















































































































































































































import {
	defineComponent,
	Ref,
	ref,
} from '@vue/composition-api';
import { Spacing } from '@front-app/components/constants';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { OrganizationType } from '@front-app/services/OrganizationsApi/OrganizationModel';
import { toEnglishString } from '@front-app/modules/organization/util/convert';
import { DEFAULT_COUNTRY_CODE, EMPTY_REGION } from '@front-app/components/inputs/CountryPickerData';
import { usePostalMask } from '@front-app/components/inputs/util';
import { OrganizationsStore } from '@front-app/store/singletons/Organizations';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import CountryPicker from '@front-app/components/inputs/CountryPicker.vue';
import RegionPicker from '@front-app/components/inputs/RegionPicker.vue';
import EditorWrapper from '@front-app/components/layouts/form/EditorWrapper.vue';
import OrganizationTypePicker from './OrganizationTypePicker.vue';

export default defineComponent({
	components: {
		FormSection,
		FormLabel,
		FormError,
		FormInput,
		OrganizationTypePicker,
		CountryPicker,
		RegionPicker,
		EditorWrapper,
	},
	props: {
		initialName: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		// Field values
		const name = ref(props.initialName);
		const organizationType: Ref<OrganizationType> = ref(OrganizationType.ALLIED_HEALTH);
		const country = ref(DEFAULT_COUNTRY_CODE);
		const region = ref(EMPTY_REGION);
		const city = ref('');
		const street1 = ref('');
		const street2 = ref('');
		const postalCode = ref('');
		const phone: Ref<null | number> = ref(null);
		const fax: Ref<null | number> = ref(null);
		// End Fields values

		// Validation
		const postalMask = usePostalMask(country);
		const validation = v({
			name: {
				value: name,
				rules: [required()],
			},
			organizationType: {
				value: organizationType,
				rules: [required()],
			},
			country: {
				value: country,
				rules: [required()],
			},
			region: {
				value: region,
				rules: [required()],
			},
			city: {
				value: city,
				rules: [required()],
			},
			street1: {
				value: street1,
				rules: [required()],
			},
			postalCode: {
				value: postalCode,
				rules: [required()],
			},
			phone: {
				value: phone,
				rules: [required()],
			},
		});
		const {
			focusFirstInvalid,
		} = useFocusFirstInvalidField({ containerSelector: '.create-organization-form' });
		// END Validation

		const {
			track,
			isLoading,
			isSuccess,
			isError,
		} = useAsyncStatus();

		// Submission
		const submit = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}
			const faxVal = fax.value;
			const phoneVal = phone.value;
			const orgTypeVal = organizationType.value;
			if (phoneVal === null || !orgTypeVal) {
				return;
			}

			const result = await track(OrganizationsStore.create({
				type: toEnglishString(orgTypeVal),
				name: name.value,
				address: {
					street1: street1.value,
					street2: street2.value,
					city: city.value,
					province: region.value,
					country: country.value,
					postal: postalCode.value,
					contactInfo: {
						phone: phoneVal.toString(),
						fax: faxVal ? faxVal.toString() : undefined,
					},
				},
			}));

			ctx.emit('created', result);
		};
		// END Submission
		return {
			// Values
			name,
			organizationType,
			country,
			region,
			city,
			street1,
			street2,
			postalCode,
			phone,
			fax,
			// Validation
			validation,
			postalMask,
			focusFirstInvalid,
			// Submission
			submit,
			isLoading,
			isSuccess,
			isError,
			// Util
			Spacing,
		};
	},
});
